<template>
  <v-container fluid>

    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"

      absolute
    >
      {{ message }}
      <v-btn
        dark

        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>

            <div :class="paginatedFiles.length === 7 ? 'viewfarmer_box' : 'viewfarmer_box_empty'">
              <v-card

                max-width="100%"
              >

                <v-card-title class="accent--text" style="font-size: 14px; font-weight:700;"> CCARF Application</v-card-title>
<!--                <v-divider class="mx-4"></v-divider>-->

                <div v-if="ifFCS()">
                <v-card-text>
                  <v-row
                    no-gutters justify="space-around"
                  >
                    <v-col
                      class="d-flex justify-left"
                     >
                      <span > Cherry Weight: {{ cherry }}  KG</span>

                    </v-col>
                    <v-col
                      class="d-flex justify-left"
                    >
                      <span > Limit: Kes {{ limit }} </span>

                    </v-col>

                    <v-col
                      class="d-flex justify-left"
                    >
                      <span > Accrued Debt: Kes {{ debt }} </span>

                    </v-col>
                  </v-row>

                                    </v-card-text>
                <v-divider ></v-divider>
                <v-card-text>

                    <v-form ref="editform" v-model="valid" lazy-validation no-gutters justify="space-around">
                      <v-row
                        no-gutters justify="space-around"
                      >
                    <v-col
                      class="d-flex justify-left "
                    >

                      <span class="accent--text" style="font-size: 12px; font-weight:600;"> Request CCARF Loan</span>

                    </v-col>
                    <v-col
                      class="d-flex justify-left"
                    >
                      <v-text-field label="Amount ( KES )" v-model="farmer.firstName"></v-text-field>

                    </v-col>
                    <v-col
                      class="d-flex justify-left ml-10"
                    >
                      <v-btn color="primary" @click="applyCcarfLoan">Apply</v-btn>
                    </v-col>

                      </v-row>

                    </v-form>

                </v-card-text>

                <v-divider ></v-divider>
                </div>
                <v-card-title class="accent--text" style="font-size: 12px; font-weight:600;"> Transaction History</v-card-title>
                <v-card-text>

      <table class="table">
              <thead class="thead">
              <tr>
                <th scope="col">Grower</th>
                <th scope="col">Name</th>
                <th scope="col">ID Number</th>
                <th scope="col">Member Number</th>
                <th scope="col">Phone</th>
                <th scope="col">Farmer Type</th>
                <th scope="col">Status</th>
                <th scope="col">Actions</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="farmer in filteredList" v-bind:key="farmer.id">
                <td> {{ farmer.organisation !== null ? farmer.organisation.organisationCode : '' }}</td>
                <td> {{ farmer.firstName }} {{ farmer.middleName }} {{ farmer.lastName }}</td>
                <td> {{ farmer.farmerId }}</td>
                <td> {{ farmer.memberNumber }}</td>
                <td>{{ farmer.mobileNumber }}</td>
                <td>{{ farmer.farmerType !== null ? farmer.farmerType.name : '' }}</td>
                <td>{{ farmer.status?.statusName }}</td>
                <td class="actions">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        color="primary"
                        v-on="on"
                        text
                        icon
                        class="actions"
                      >
                        <v-icon class="secondary--text"> more_horiz</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item @click="showEditDialog(farmer)" v-if="canEditFarmer()">
                        <v-list-item-title> Edit</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeActivated(farmer)" @click="disableAction(farmer, 'activate')">
                        <v-list-item-title> ReActivate</v-list-item-title>
                      </v-list-item>
                      <v-list-item v-if="canBeDeactivated(farmer)" @click="disableAction(farmer, 'deactivate')">
                        <v-list-item-title> Deactivate</v-list-item-title>
                      </v-list-item>
<!--                      <v-list-item :to="`/farmers/loan/history/${farmer.id}`">-->
<!--                        <v-list-item-title> Edit History</v-list-item-title>-->
<!--                      </v-list-item>-->
                      <v-list-item :to="`/farmers/loan/history/${farmer.id}`">
                        <v-list-item-title> Loan History</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="viewBankDetails(farmer)">
                        <v-list-item-title> Bank Details</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="downloadStatement(farmer)">
                        <v-list-item-title> Download Statement</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </td>
              </tr>
              </tbody>
            </table>
          </v-card-text>

          <v-card-actions>
            <span class="paginationtext"> Showing {{ page }} of {{ numberOfLinks }} pages </span>
            <v-spacer></v-spacer>
            <v-pagination
              v-model="page"
              :length="numberOfLinks"
              color="secondary"
                class="accent--text logoutbtn"
            ></v-pagination>
          </v-card-actions>
    </v-card>
    </div>

    <v-dialog v-model="bankDetailsDialog" persistent max-width="500" v-if="this.farmerBankDetail !== null">
      <v-card>
        <v-card-title class="headline primary--text">Bank Details</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" md="6">
              <h5> Account Name: </h5>
            </v-col>
            <v-col cols="6" md="6">
              {{ this.farmerBankDetail !== null ? this.farmerBankDetail.accountName : '' }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="6">
              <h5> Account No: </h5>
            </v-col>
            <v-col cols="6" md="6">
              {{ this.farmerBankDetail !== null ? this.farmerBankDetail.account : '' }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="6">
              <h5> Bank Name: </h5>
            </v-col>
            <v-col cols="6" md="6">
              {{ this.farmerBankDetail !== null ? this.farmerBankDetail.bank.bankName : '' }}
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeBankDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editDialog" persistent max-width="700">
      <v-card>
        <v-card-title class="headline primary--text">Edit Farmer</v-card-title>
        <v-card-text>
          <v-form ref="editform" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs5>
                <v-text-field label="First Name" v-model="farmer.firstName"></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>

              <v-flex xs5>
                <v-text-field label="Last Name" v-model="farmer.lastName"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5>
                <v-text-field label="Middle Name" v-model="farmer.middleName"></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs5>
                <v-text-field label="Farmer Id" v-model="farmer.farmerId"></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout>
              <v-flex xs5>
                <v-text-field label="Mobile No" v-model="farmer.mobileNumber"></v-text-field>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs5>
                <v-text-field label="Member  No" v-model="farmer.memberNumber"></v-text-field>
              </v-flex>

            </v-layout>
            <v-layout>

              <v-flex xs5>
                <v-text-field label="Gender" v-model="farmer.gender"></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs5>
                <v-autocomplete v-model="farmer.farmerBankDetail.bank.bankCode" :items="banks" item-text="bankName"
                                item-value="bankCode" label="Bank"></v-autocomplete>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs5>
                <v-text-field label="Bank Account" v-model="farmer.farmerBankDetail.account"></v-text-field>
              </v-flex>
            </v-layout>

          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" text @click="editDialog = false">Close</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="editRecord">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="disableDialog" max-width="500">
      <v-card>
        <v-card-title class="headline accent--text text-capitalize">{{ this.action }} Farmer</v-card-title>
        <v-card-text>
          <v-flex xs12>
            <p class="font-weight-regular subheading"> {{ confirmMessage }} </p>
          </v-flex>
        </v-card-text>

        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="disableDialog = false"
            class="font-weight-bold"
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            class="white--text logoutbtn"
            @click="activateOrDeactivate(disableFarmer)"
          >

            {{ this.action==='activate' ? 'Activate' : 'Deactivate' }}

          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import themes from 'devextreme/ui/themes'

export default {
	name: 'viewfarmers',
	data: function () {
		return {
			valid: true,
			message: '',
			snackbar: false,
			snackbarColor: '',
			farmers: [],
			totalFarmers: 0,
			pagination: { sortBy: 'id', descending: true },
			search: '',
			paginatedFiles: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			page: 1,
			farmerBankDetail: null,
			editDialog: false,
			disableDialog: false,
			farmer: { farmerBankDetail: { bank: {} } },
			banks: [],
			permissions: [],
			disableFarmer: {},
			confirmMessage: '',
			fcsCode: '',
			cherry: 0.00,
			debt: 0.00,
			limit: 0.00,
			action: '',
			isFcs: ' '
		}
	},
	mounted () {
		this.getFarmers()
		this.getBanks()

		this.permissions = store.state.user.roleId.permissions
		this.isFcs = store.state.user.organisation.organisationType.name === 'FARMER_SOCIETY'
		this.fcsCode = store.state.user?.organisation?.organisationCode
		this.getCherryWeight()
		this.getAccruedDebt()
	},
	watch: {

		farmers () {
			this.paginatedFiles = this.paginationMethod(this.farmers, 1, this.numberOfItemsPerPage)
			this.numberOfLinks = Math.ceil(this.farmers.length / this.numberOfItemsPerPage)
		},
		page: function (val) {
			this.paginatedFiles = this.paginationMethod(this.farmers, val, this.numberOfItemsPerPage)
		}
	},
	computed: {
		filteredList: function () {
			if (this.search === '') {
				return this.paginatedFiles
			} else {
				return this.farmers.filter(farmer => {
					return (farmer.firstName !== null ? farmer.firstName.toLowerCase().includes(this.search.toLowerCase()) : ''.toLowerCase().includes(this.search.toLowerCase())) || (farmer.lastName === null ? ''.toLowerCase().includes(this.search.toLowerCase()) : farmer.lastName.toLowerCase().includes(this.search.toLowerCase())) || farmer.farmerId.toLowerCase().includes(this.search.toLowerCase()) || farmer.mobileNumber.includes(this.search) || farmer.memberNumber.includes(this.search)
				})
			}
		}
	},
	methods: {

		activateOrDeactivate (item) {
			this.disableDialog = true
			if (this.action === 'deactivate' || this.action === 'activate') {
				const deactivate = this.action === 'deactivate'

				const url = config.serverURI + '/farmer/manage?id=' + item.id + '&deactivate=' + deactivate
				axios.post(url)
					.then(response => {
						this.disableDialog = false
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'

							return
						}
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.getFarmers()
					})
					.catch(error => {
						console.log('error', error.response)
						this.message = typeof error.response.data.message !== 'undefined' ? error.response.data.message : error.response.status
						this.snackbar = true
						this.snackbarColor = 'error'
					})
				this.disableDialog = false
			} else {
				this.message = 'Unsupported Action'
				this.snackbar = true
				this.snackbarColor = 'error'
				this.disableDialog = false
			}
		},

		disableAction (item, action) {
			this.disableFarmer = item
			this.disableDialog = true
			this.action = action
			if (action === 'activate') {
				this.confirmMessage = 'Do you want to Activate  ' + item?.fullName + ' ?'
			} else if (action === 'deactivate') {
				this.confirmMessage = 'Do you want to Deactivate ' + item?.fullName + ' ?'
			} else {
				console.error(action + 'Action not supported')
			}
		},

		canBeDeactivated (item) {
			if (item?.status === null) {
				return false
			}
			return 	(item.status.id === 33) // Active
			// && this.hasPerm('CAN_APPROVE_LIMITS')
		},
		canBeActivated (item) {
			if (item.status === null) {
				return false
			}
			return (item.status.id === 2) // && this.hasPerm('CAN_APPROVE_LIMITS')
			// Disabled
		},
		paginationMethod (items, pageNumber, limitPerPage) {
			pageNumber = pageNumber - 1
			const from = pageNumber * limitPerPage
			let to = (pageNumber + 1) * limitPerPage
			if (to >= items.length) {
				to = items.length
			}
			return items.slice(from, to)
		},
		ifFCS () {
			return this.isFcs
		},
		hasPerm (permission) {
			return this.permissions.includes(permission)
		},
		getFarmers () {
			const url = config.serverURI + '/upload/cherry/farmer'
			axios.get(url)
				.then(response => {
					this.farmers = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},

		getCherryWeight () {
			if (this.isFcs) {
				const url = config.serverURI + '/ccarf/fcs/cherry/weight?growerCode=' + this.fcsCode
				axios.get(url)
					.then(response => {
						this.cherry = response.data[0].weight
					})
					.catch(error => {
						console.log('error', error.response)
					})
			}
		},

		getAccruedDebt () {
			if (this.isFcs) {
				const url = config.serverURI + '/ccarf/fcs/accruedDebt?growerCode=' + this.fcsCode
				axios.get(url)
					.then(response => {
						this.debt = response.data[0].accruedDebt
					})
					.catch(error => {
						console.log('error', error.response)
					})
			}
		},
		viewBankDetails (item) {
			this.bankDetailsDialog = true
			this.farmerBankDetail = item.farmerBankDetail
			// console.log(this.farmerBankDetail)
		},
		closeBankDialog () {
			this.farmerBankDetail = null
			this.bankDetailsDialog = false
		},
		showEditDialog (farmer) {
			// console.log(farmer)
			this.editDialog = true
			this.farmer = farmer
		},
		applyCcarfLoan () {

		},
		editRecord () {
			if (this.$refs.editform.validate()) {
				const url = config.serverURI + '/farmer/edit'
				axios.post(url, {
					id: this.farmer?.id,
					firstName: this.farmer?.firstName,
					lastName: this.farmer?.lastName,
					middleName: this.farmer?.middleName,
					memberNumber: this.farmer?.memberNumber,
					gender: this.farmer?.gender,
					farmerId: this.farmer?.farmerId,
					bankCode: this.farmer?.farmerBankDetail?.bank?.bankCode,
					account: this.farmer?.farmerBankDetail?.account,

					mobileNumber: this.farmer?.mobileNumber

				})
					.then(response => {
						// console.log('Response', response.data)
						if (response.data.error !== false) {
							this.message = response.data.message
							this.snackbar = true
							this.snackbarColor = 'error'
							console.log('Error is ' + this.message)
							return
						}
						this.$refs.editform.resetValidation()
						this.message = response.data.message
						this.snackbar = true
						this.snackbarColor = 'primary'
						this.editDialog = false
					})
					.catch(error => {
						// console.log('error', error.response)
						// console.log('error', error.response.data.message)
						this.message = error.response.data.message
						this.snackbar = true
						this.snackbarColor = 'error'
					})

				this.getFarmers()
			}
		},
		getBanks () {
			const url = config.serverURI + '/bank'
			axios.get(url)
				.then(response => {
					this.banks = response.data
				})
				.catch(error => {
					console.log('error', error.response)
				})
		},
		canEditFarmer () {
			return this.hasPerm('CAN_UPDATE_FARMER')
		},
		downloadStatement (farmer) {
			const url = config.serverURI + `/farmer/loan_statement/${farmer.id}`
			this.loading = true
			axios({ url: url, method: 'GET', responseType: 'blob' })
				.then(response => {
					this.loading = false
					const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
					const link = document.createElement('a')
					link.href = url
					const itemFileName = `loanstatement_${farmer.id}.pdf`
					link.setAttribute('download', itemFileName)
					document.body.appendChild(link)
					link.click()
				})
				.catch(error => {
					this.loading = false
					console.log('error', error.response)
				})
		}
	}
}

</script>
<style>
.viewfarmer_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.viewfarmer_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.catalogue_box:after, .catalogue_box:before {
  right: 100%;
  top: 17%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.catalogue_box:after {
  border-color: rgba(255, 255, 255, 0);
  border-right-color: #fff;
  border-width: 20px;
  margin-top: -20px;
}

.catalogue_box:before {
  border-color: rgba(112, 112, 112, 0);
  border-right-color: #707070;
  border-width: 21px;
  margin-top: -21px;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}
</style>
